export const messages = {
  en: {
    changeStaffPwd: {
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      oldPasswordPlaceholder: 'Required, please enter old password',
      newPasswordPlaceholder: 'Required, please enter new password',
      confirmPasswordPlaceholder: 'Required, please confirm password',
      confirmChange: 'Confirm Change',
      oldPasswordRequired: 'Old password is required',
      newPasswordRequired: 'New password is required',
      confirmPasswordRequired: 'Confirm password is required',
      passwordNotMatch: 'Passwords do not match',
      changeSuccess: 'Password changed successfully'
    }
  },
  zh: {
    changeStaffPwd: {
      oldPassword: '原始密码',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      oldPasswordPlaceholder: '必填，请输入原始密码',
      newPasswordPlaceholder: '必填，请输入新密码',
      confirmPasswordPlaceholder: '必填，请输入确认密码',
      confirmChange: '确认修改',
      oldPasswordRequired: '原始密码不能为空',
      newPasswordRequired: '新密码不能为空',
      confirmPasswordRequired: '确认密码不能为空',
      passwordNotMatch: '两次密码不一致',
      changeSuccess: '修改成功'
    }
  }
}